<template>
  <div
    class="success-modal"
    v-if="modal"
  >
    <span
      class="success-modal__title"
      v-text="modal.title"
    />
    <div class="success-modal__title-separator" />

    <div class="success-modal__content">
      <img
        class="success-modal__image"
        :src="modal.imageSrc"
        :alt="modal.title"
      />

      <p
        class="success-modal__message"
        v-text="modal.message"
      />

      <el-button
        type="primary"
        class="success-modal__button"
        @click="modal.onButtonClick"
      >
        <span v-text="modal.buttonCaption" />
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

import { i18n } from '@shared/i18n'

import inscriptionPendingImage from '@/assets/inscription-pending.svg'
import resetPasswordImage from '@/assets/reset-password.png'

export default {
  name: 'success-modal',
  props: {
    type: {
      type: String,
      default: 'inscription',
    }
  },
  data() {
    return {
      types: {
        inscription: {
          title: i18n('entities.inscription.pending.title'),
          imageSrc: inscriptionPendingImage,
          message: i18n('entities.inscription.pending.message'),
          buttonCaption: i18n('entities.inscription.pending.buttonCaption'),
          onButtonClick: () => {
            this.setSuccessModalVisible(false)
            this.navigateHome()
          }
        },
        resetPassword: {
          title: i18n('auth.passwordResetEmail.success.title'),
          imageSrc: resetPasswordImage,
          message: i18n('auth.passwordResetEmail.success.message'),
          buttonCaption: i18n('auth.passwordResetEmail.success.buttonCaption'),
          onButtonClick: () => {
            this.setSuccessModalVisible(false)
            this.navigateHome()
          }
        },
      }
    }
  },
  computed: {
    modal() {
      return this.type in this.types && this.types[this.type]
    },
    slug() {
      return this.$route.params.slug
    },
  },
  methods: {
    ...mapMutations({
      setSuccessModalVisible: 'setSuccessModalVisible',
    }),
    navigateHome() {
      this.$router.push({
        name: 'home',
        params: {
          slug: this.slug,
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.success-modal {
  @include modal-mixin;

  &__content {
    @include small-mobile {
      grid-template-columns: 300px;
      padding-bottom: 40px;
    }
    display: grid;
    grid-template-columns: 400px;
    grid-template-rows: 230px auto 40px;
    grid-gap: 32px;
    align-items: center;
    justify-items: center;
    justify-content: center;
    margin: 0 auto;
  }

  &__image {
    width: auto;
    height: 230px;
    margin: 20px 0 10px;
  }

  &__message {
    font-size: 20px;
    font-weight: normal;
    text-align: center;
    color: #404040;
    word-break: break-word;
  }

  &__button {
    width: 212px;
  }
}
</style>
